import React, { useState } from "react";
import { Stack, Image } from "react-bootstrap";
import SolarEstimator from "./SolarEstimator/SolarEstimator";
import SystemCalculator from "./SystemCalculator/SystemCalculator";
import VoltageDropCalculator from "./VoltageDropCalculator/VoltageDropCalculator";
import ElectricalCalculator from "./ElectricalCalculator/ElectricalCalculator";
import "./style.css";
import { MdSolarPower, MdElectricMeter  } from "react-icons/md";
import { GiSolarPower } from "react-icons/gi";
import { TbSunElectricity } from "react-icons/tb";


const CALCULATORS = [
  {
    id: "solar",
    title: "Solar Estimator",
    description: "Personalized USA solar estimate with incentives, savings, roof fit, and financing.",
    icon: <MdSolarPower size={28}/>,
  },
  {
    id: "system",
    title: "System Calculator",
    description: "Roof fit and panel system size calculator for residential solar projects.",
    icon: <GiSolarPower size={28}/>,
  },
  {
    id: "mppt",
    title: "Voltage Drop Calculator",
    description: "Calculate solar wire voltage drop, power loss, and NEC recommendation status.",
    icon: <TbSunElectricity size={28}/>,
  },
  {
    id: "electrical",
    title: "Electrical Calculator",
    description: "AC/DC current, breaker, and inverter sizing guidance for rooftop solar systems.",
    icon: <MdElectricMeter size={28}/>,
  },
];

function ToolCard({ tool, onSelect, active }) {
  return (
    <div className={`se-tool-card ${active ? "se-tool-card-selected" : ""}`} onClick={() => onSelect(tool.id)}>
      <div className="se-card-icon">
        {tool.icon}
      </div>
      <div>
        <div className="se-card-title">{tool.title}</div>
        <div className="se-card-sub">{tool.description}</div>
      </div>
      <div style={{ marginTop: 18, fontWeight: 700, color: active ? "#7C3AED" : "#6b7280" }}>
        {active ? "Selected" : "Select tool"}
      </div>
    </div>
  );
}

const TOOL_COMPONENTS = {
  solar: SolarEstimator,
  system: SystemCalculator,
  mppt: VoltageDropCalculator,
  electrical: ElectricalCalculator,
};

export default function Calculators() {
  const [selectedTool, setSelectedTool] = useState("");
  const selectedToolData = CALCULATORS.find(tool => tool.id === selectedTool);
  const SelectedToolComponent = TOOL_COMPONENTS[selectedTool] || null;

  return (
    <div className="se-wrap se-calculators-page">
          <Stack direction="horizontal" gap={2} className="justify-content-center mb-5">
            <Image src="/images/LOGO-07.png" alt="ReyZap CRM Logo" style={{ width: "20rem" }}/>
          </Stack>
      {!selectedTool ? (
        <>
          <div className="se-hero se-hero-center">
            {/* <div className="se-hero-badge">☀ Solar Calculators</div> */}
            <h1 className="se-hero-h1">Choose a calculator</h1>
            <p className="se-hero-p">Select from four USA-based solar tools and get accurate results for your home.</p>
          </div>
          <div className="se-tools-grid">
            {CALCULATORS.map(tool => (
              <ToolCard key={tool.id} tool={tool} onSelect={setSelectedTool} active={selectedTool === tool.id} />
            ))}
          </div>
        </>
      ) : (
        <div className="se-calculator-view">
          <div className="se-tool-shell-header">
            {selectedToolData && (
              <div className="se-tool-shell-title-group">
                <div className="se-tool-shell-label">{selectedToolData.title}</div>
                <div className="se-tool-shell-sub">{selectedToolData.description}</div>
              </div>
            )}
            <button className="se-btn-back se-tool-back" onClick={() => setSelectedTool("")}>← Back</button>
          </div>
          <div className="se-tool-shell-body">
            {SelectedToolComponent ? <SelectedToolComponent /> : null}
          </div>
        </div>
      )}
    </div>
  );
}
